import {deserialize} from 'serializr'
import User from '../../server/model/User'

(function () {
    const loggedInUserJson = JSON.parse(document.getElementById('logged-in-user')?.innerHTML || "null")
    window.loggedInUser = loggedInUserJson ? deserialize(User, loggedInUserJson) : null
})();